<template>
    <div class="home">

        <div class="row">
            <div class="grid_col_8 grid_col_m_8 grid_col_s_12 grid_col_xs_12">
                <div class="row">
                    <!-- Estatísticas do Dashboard -->
                    <div class="grid_col_12">
                        <div class="row row_align_stretch" :class="{ 'home_stats--loading': loadingStats }">
                            <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12 home_stats_card home_stats_card--primary">
                                <div class="home_stats_card_header">
                                    <div class="home_stats_card_icon">
                                        <sw-icon name="file-text" />
                                    </div>
                                    <div class="home_stats_card_number">{{ dashboardStats.totalDocuments || 0 }}</div>
                                </div>
                                <div class="home_stats_card_body">
                                    <div class="home_stats_card_title">Total de Arquivos</div>
                                    <div class="home_stats_card_subtitle">
                                        <span class="home_stats_card_badge home_stats_card_badge--success">
                                            +{{ dashboardStats.recentUploads || 0 }}
                                        </span>
                                        adicionados este mês
                                    </div>
                                </div>
                            </div>

                            <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12 home_stats_card home_stats_card--warning">
                                <div class="home_stats_card_header">
                                    <div class="home_stats_card_icon">
                                        <sw-icon name="alarm" />
                                    </div>
                                    <div class="home_stats_card_number home_stats_card--clickable" @click="openExpiringModal">
                                        {{ dashboardStats.expiringDocuments || 0 }}
                                        <sw-icon name="arrow-right" class="home_stats_card_action" />
                                    </div>
                                </div>
                                <div class="home_stats_card_body">
                                    <div class="home_stats_card_title">Vencendo em Breve</div>
                                    <div class="home_stats_card_subtitle">
                                        Próximos <span class="home_stats_card_highlight">30 dias</span>
                                    </div>
                                </div>
                            </div>

                            <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12 home_stats_card home_stats_card--danger">
                                <div class="home_stats_card_header">
                                    <div class="home_stats_card_icon">
                                        <sw-icon name="cross" />
                                    </div>
                                    <div class="home_stats_card_number home_stats_card--clickable" @click="openExpiredModal">
                                        {{ dashboardStats.expiredDocuments || 0 }}
                                        <sw-icon name="arrow-right" class="home_stats_card_action" />
                                    </div>
                                </div>
                                <div class="home_stats_card_body">
                                    <div class="home_stats_card_title">Arquivos Vencidos</div>
                                    <div class="home_stats_card_subtitle">
                                        <span class="home_stats_card_highlight">Ação necessária</span>
                                    </div>
                                </div>
                            </div>

                            <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12 home_stats_card home_stats_card--storage">
                                <div class="home_stats_card_header">
                                    <div class="home_stats_card_icon">
                                        <sw-icon name="drive" />
                                    </div>
                                    <div class="home_stats_card_number">{{ dashboardStats.storageUsed || '0 MB' }}</div>
                                </div>
                                <div class="home_stats_card_body">
                                    <div class="home_stats_card_title">Armazenamento Usado</div>
                                    <div class="home_stats_card_subtitle">
                                        <span class="home_stats_card_highlight">{{ dashboardStats.storageLimit || '100 MB' }}</span> disponíveis
                                    </div>
                                </div>
                                <div class="home_stats_card_storageBar">
                                    <div
                                        class="home_stats_card_storageProgress"
                                        :style="{ width: `${dashboardStats.storagePercentage || 0}%` }"
                                    ></div>
                                </div>
                            </div>

                            <div class="grid_col_12">
                                <div class="home_stats_card home_stats_card--wide home_stats_card--activity">
                                    <div class="home_stats_card_activityHeader">
                                        <div class="home_stats_card_icon">
                                            <sw-icon name="clock" />
                                        </div>
                                        <div class="home_stats_card_title">Atividades do Sistema</div>
                                        <div class="home_stats_card_subtitle">
                                            Uso atual dos <span class="home_stats_card_highlight">recursos do sistema</span>
                                        </div>
                                    </div>
                            <div class="home_stats_card_activityGrid">
                                <div class="row">
                                    <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12">
                                        <div class="home_stats_activity_item">
                                            <div class="home_stats_activity_icon">
                                                <sw-icon name="mail" />
                                            </div>
                                            <div class="home_stats_activity_data">
                                                <div class="home_stats_activity_usage">
                                                    <span class="home_stats_activity_used">{{ planResources.sends.used }}</span>
                                                    <span class="home_stats_activity_separator">/</span>
                                                    <span class="home_stats_activity_total">{{ planResources.sends.total }}</span>
                                                </div>
                                                <span class="home_stats_activity_label">Envios</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12">
                                        <div class="home_stats_activity_item">
                                            <div class="home_stats_activity_icon">
                                                <sw-icon name="alarm" />
                                            </div>
                                            <div class="home_stats_activity_data">
                                                <div class="home_stats_activity_usage">
                                                    <span class="home_stats_activity_used">{{ planResources.alerts.used }}</span>
                                                    <span class="home_stats_activity_separator">/</span>
                                                    <span class="home_stats_activity_total">{{ planResources.alerts.total }}</span>
                                                </div>
                                                <span class="home_stats_activity_label">Alertas</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12">
                                        <div class="home_stats_activity_item">
                                            <div class="home_stats_activity_icon">
                                                <sw-icon name="earth" />
                                            </div>
                                            <div class="home_stats_activity_data">
                                                <div class="home_stats_activity_usage">
                                                    <span class="home_stats_activity_used">{{ planResources.uploads.used }}</span>
                                                    <span class="home_stats_activity_separator">/</span>
                                                    <span class="home_stats_activity_total">{{ planResources.uploads.total }}</span>
                                                </div>
                                                <span class="home_stats_activity_label">Paginas Uploads</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="grid_col_3 grid_col_m_6 grid_col_s_12 grid_col_xs_12">
                                        <div class="home_stats_activity_item">
                                            <div class="home_stats_activity_icon">
                                                <sw-icon name="earth" />
                                            </div>
                                            <div class="home_stats_activity_data">
                                                <div class="home_stats_activity_usage">
                                                    <span class="home_stats_activity_used">{{ planResources.sharePages.used }}</span>
                                                    <span class="home_stats_activity_separator">/</span>
                                                    <span class="home_stats_activity_total">{{ planResources.sharePages.total }}</span>
                                                </div>
                                                <span class="home_stats_activity_label">Páginas Compartilhadas</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Arquivos por Categoria -->
                    <Box
                        :key="`box-${organizationType}`"
                        class="grid_col_12"
                        :title="currentDataTitle"
                        :sub-title="currentDataSubtitle"
                        :icon="currentDataIcon"
                        :variant="BOX_VARIANTS.SECONDARY"
                        :loading="loadingCategories"
                        :actions="categoryActions"
                        @select-change="handleOrganizationChange"
                    >
                        <div class="row" v-if="!loadingCategories && currentData.length > 0">
                            <div
                                v-for="item in currentData"
                                :key="item.name"
                                class="grid_col_3 grid_col_m_3 grid_col_s_6 grid_col_xs_12"
                            >
                                <div class="categoryCard">
                                    <div class="categoryCard_header">
                                        <!-- Empresa com imagem -->
                                        <div
                                            v-if="organizationType === ORGANIZATION_TYPES.COMPANY && item.image"
                                            class="categoryCard_image"
                                        >
                                            <img :src="item.image" :alt="item.name" />
                                        </div>
                                        <!-- Ícone padrão - SOMENTE para empresas sem imagem -->
                                        <div
                                            v-else-if="organizationType === ORGANIZATION_TYPES.COMPANY"
                                            class="categoryCard_icon"
                                        >
                                            <sw-icon :name="getItemIcon(item)" />
                                        </div>
                                        <div class="categoryCard_info">
                                            <div class="categoryCard_title">{{ item.name }}</div>
                                            <div class="categoryCard_count">{{ item.count }} arquivos</div>
                                        </div>
                                    </div>
                                    <div class="categoryCard_body">
                                        <div class="categoryCard_stats">
                                            <div class="categoryCard_stat">
                                                <span class="categoryCard_stat_value categoryCard_stat_value--expiring">{{ item.stats.expiring }}</span>
                                                <span class="categoryCard_stat_label">Vencendo</span>
                                            </div>
                                            <div class="categoryCard_stat">
                                                <span class="categoryCard_stat_value categoryCard_stat_value--expired">{{ item.stats.expired }}</span>
                                                <span class="categoryCard_stat_label">Vencidos</span>
                                            </div>
                                        </div>
                                        <sw-button
                                            name="Exibir"
                                            size="sm"
                                            color="blue"
                                            @click="viewCategory(item)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="home_emptyState" v-else-if="!loadingCategories && currentData.length === 0">
                            <div class="home_emptyState_icon">
                                <sw-icon :name="currentDataIcon" />
                            </div>
                            <div class="home_emptyState_title">
                                {{ organizationType === ORGANIZATION_TYPES.CATEGORY ? 'Nenhuma categoria encontrada' : 'Nenhum tipo encontrado' }}
                            </div>
                            <div class="home_emptyState_subtitle">
                                {{ organizationType === ORGANIZATION_TYPES.CATEGORY
                                    ? 'Adicione arquivos para que as categorias apareçam aqui.'
                                    : 'Adicione arquivos para que os tipos apareçam aqui.'
                                }}
                            </div>
                        </div>
                    </Box>
                </div>
            </div>

            <div class="grid_col_4 grid_col_m_4 grid_col_s_12 grid_col_xs_12 grid_last">
                <div class="row">
                    <!-- Atividades Recentes -->
                    <div class="grid_col_12">
                        <div class="home_recentActivities" :class="{ 'home_recentActivities--loading': loadingActivities }">
                            <div class="home_recentActivities_header">
                                <div class="home_recentActivities_title">
                                    <sw-icon name="clock" />
                                    <h3>Atividades Recentes</h3>
                                </div>
                                <div class="home_recentActivities_count">{{ recentActivities.length }}</div>
                            </div>
                            
                            <div class="home_recentActivities_content">
                                <div 
                                    v-if="!loadingActivities && recentActivities.length > 0"
                                    class="home_recentActivities_list"
                                >
                                    <div
                                        v-for="activity in recentActivities.slice(0, 10)"
                                        :key="activity.id"
                                        class="home_recentActivities_item"
                                    >
                                        <div class="home_recentActivities_itemContent">
                                            <div class="home_recentActivities_itemTitle">
                                                <div class="home_recentActivities_itemHeader">
                                                    <div class="home_recentActivities_itemIcon" :class="`home_recentActivities_itemIcon--${activity.type}`">
                                                        <sw-icon :name="getActivityIcon(activity.type)" />
                                                    </div>
                                                    <span class="activity-action">{{ activity.action }}</span>
                                                </div>
                                                <span class="activity-description">{{ activity.description }}</span>
                                            </div>
                                            <div class="home_recentActivities_itemTime">{{ formatRelativeTime(activity.timestamp) }}</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div 
                                    v-else-if="!loadingActivities && recentActivities.length === 0"
                                    class="home_recentActivities_empty"
                                >
                                    <sw-icon name="clock" />
                                    <p>Nenhuma atividade recente</p>
                                    <span>Atividades aparecerão aqui quando ocorrerem</span>
                                </div>
                                
                                <div v-else class="home_recentActivities_loading">
                                    <app-spinner />
                                </div>
                            </div>
                            
                            <div class="home_recentActivities_footer" v-if="recentActivities.length > 10">
                                <sw-button 
                                    name="Ver Todas" 
                                    color="gray" 
                                    size="sm"
                                    @click="viewAllActivities"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Arquivos a Vencer -->
                    <div class="grid_col_12">
                        <div class="home_expiringDocs" :class="{ 'home_expiringDocs--loading': loadingExpiring }">
                            <div class="home_expiringDocs_header">
                                <div class="home_expiringDocs_title">
                                    <sw-icon name="bell" />
                                    <h3>Arquivos a Vencer</h3>
                                </div>
                                <div class="home_expiringDocs_count">{{ expiringDocuments.length }}</div>
                            </div>
                            
                            <div class="home_expiringDocs_content">
                                <div
                                    v-if="!loadingExpiring && expiringDocuments.length > 0"
                                    class="home_expiringDocs_list"
                                >
                                    <FileCard
                                        v-for="document in expiringDocuments.slice(0, 3)"
                                        :key="document.id"
                                        :document="document"
                                        :variant="FILE_CARD_VARIANTS.MINIMAL"
                                        :loading="false"
                                    />
                                </div>
                                
                                <div 
                                    v-else-if="!loadingExpiring && expiringDocuments.length === 0"
                                    class="home_expiringDocs_empty"
                                >
                                    <sw-icon name="checkmark" />
                                    <p>Todos os arquivos em dia!</p>
                                    <span>Nenhum arquivo vence nos próximos 30 dias</span>
                                </div>
                                
                                <div v-else class="home_expiringDocs_loading">
                                    <app-spinner />
                                </div>
                            </div>
                            
                            <div class="home_expiringDocs_footer" v-if="expiringDocuments.length > 3">
                                <sw-button 
                                    name="Ver Todos" 
                                    color="gray" 
                                    size="sm"
                                    @click="viewAllExpiring"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Últimos Arquivos Inseridos -->
        <div class="row">
            <Box 
                class="grid_col_12"
                title="Últimos Arquivos"
                sub-title="Arquivos recentemente adicionados ao sistema"
                icon="folder"
                :variant="BOX_VARIANTS.PRIMARY"
                :loading="loadingDocuments"
                :actions="[
                    {
                        icon: 'plus',
                        title: 'Novo Arquivo',
                        click: 'addNewDocument'
                    },
                    {
                        icon: 'list2',
                        title: 'Ver Todos',
                        click: 'viewAllDocuments'
                    }
                ]"
                @action-click="handleAction"
            >
                <div class="row" v-if="!loadingDocuments && documents.length > 0">
                    <div 
                        v-for="document in documents" 
                        :key="document.id"
                        class="grid_col_3 grid_col_m_4 grid_col_s_6 grid_col_xs_12"
                    >
                        <FileCard
                            :document="document"
                            :loading="false"
                        />
                    </div>
                </div>
                
                <div class="home_emptyState" v-else-if="!loadingDocuments && documents.length === 0">
                    <div class="home_emptyState_icon">
                        <sw-icon name="folder" />
                    </div>
                    <div class="home_emptyState_title">Nenhum arquivo encontrado</div>
                    <div class="home_emptyState_subtitle">
                        Comece adicionando seu primeiro arquivo ao sistema FileSave
                    </div>
                    <sw-button 
                        name="Adicionar Arquivo"
                        color="blue"
                        @click="addNewDocument"
                    />
                </div>
            </Box>
        </div>
        
        <!-- Modal de Categoria -->
        <sw-modal
            name="viewCategoryModal"
            :visible="showCategoryModal"
            @update="closeCategoryModal"
        >
            <template #header>
                <ModalHeader
                    :icon="getDocumentIcon(selectedCategory?.name)"
                    :title="selectedCategory?.name || 'Carregando...'"
                    :subtitle="selectedCategory?.count ? `${selectedCategory.count} arquivos` : ''"
                    :color="MODAL_HEADER_COLORS.BLUE"
                />
            </template>

            <template #content>
                <div class="categoryModalContent">
                    <div class="row">
                        <div
                            v-for="document in selectedCategory?.documents"
                            :key="document.id"
                            class="grid_col_4 grid_col_m_6 grid_col_s_6 grid_col_xs_12"
                        >
                            <FileCard
                                :document="document"
                                :loading="false"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </sw-modal>

        <!-- Modal de Arquivos Vencendo -->
        <sw-modal
            name="viewExpiringModal"
            :visible="showExpiringModal"
            @update="closeExpiringModal"
        >
            <template #header>
                <ModalHeader
                    icon="alarm"
                    title="Arquivos Vencendo em Breve"
                    :subtitle="`${expiringDocumentsForModal.length} arquivos vencem nos próximos 30 dias`"
                    :color="MODAL_HEADER_COLORS.ORANGE"
                />
            </template>

            <template #content>
                <div class="categoryModalContent">
                    <div class="row">
                        <div
                            v-for="document in expiringDocumentsForModal"
                            :key="document.id"
                            class="grid_col_6 grid_col_m_6 grid_col_s_6 grid_col_xs_12"
                        >
                            <FileCard
                                :document="document"
                                :loading="false"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </sw-modal>

        <!-- Modal de Arquivos Vencidos -->
        <sw-modal
            name="viewExpiredModal"
            :visible="showExpiredModal"
            @update="closeExpiredModal"
        >
            <template #header>
                <ModalHeader
                    icon="cross"
                    title="Arquivos Vencidos"
                    :subtitle="`${expiredDocumentsForModal.length} arquivos vencidos requerem atenção`"
                    :color="MODAL_HEADER_COLORS.RED"
                />
            </template>

            <template #content>
                <div class="categoryModalContent">
                    <div class="row">
                        <div
                            v-for="document in expiredDocumentsForModal"
                            :key="document.id"
                            class="grid_col_6 grid_col_m_6 grid_col_s_6 grid_col_xs_12"
                        >
                            <FileCard
                                :document="document"
                                :loading="false"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </sw-modal>

        <!-- Modal removido - agora está integrado no componente FileCard -->
    </div>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue';
    import moment from 'moment';

    import { fetchRecentDocuments, downloadDocument as apiDownloadDocument, fetchDocumentById, fetchDashboardStats, fetchExpiringDocuments, fetchExpiredDocuments, fetchDocumentsByCategory, fetchDocumentsByGroup } from '@/services/mockApi';
    import { recentActivitiesData, mockPlanResources, mockDocumentTypes, mockCompanies } from '@/data/mockData';
    import { fetchCurrentUser } from '@/services/mockApi';
    import {
        ORGANIZATION_TYPES,
        ORGANIZATION_OPTIONS,
        FILE_ICONS,
        ACTION_TYPES,
        BOX_VARIANTS,
        FILE_STATUS_LABELS,
        ACTIVITY_ICONS,
        API_STATUS,
        FILE_CARD_VARIANTS,
        MODAL_HEADER_COLORS
    } from '@/constants';

    import Box from '@Component/boxs/BoxComponent';
    import FileCard from '@Component/FileCard';
    import ModalHeader from '@Component/modals/ModalHeader';

    const loadingDocuments = ref(false);
    const documents = ref([]);
    const error = ref(null);

    // Statistics state
    const loadingStats = ref(false);
    const dashboardStats = ref({});

    // Expiring documents state
    const loadingExpiring = ref(false);
    const expiringDocuments = ref([]);

    // Recent activities state
    const loadingActivities = ref(false);
    const recentActivities = ref([]);
    const currentUser = ref(null);

    // Modal state
    const showModal = ref(false);
    const selectedDocumentId = ref(null);
    const selectedDocument = ref(null);
    const loadingDocument = ref(false);
    const documentError = ref(null);
    const downloadingDocument = ref(false);

    // Category Modal state
    const showCategoryModal = ref(false);
    const selectedCategory = ref(null);

    // Expiring/Expired Modals state
    const showExpiringModal = ref(false);
    const showExpiredModal = ref(false);
    const expiringDocumentsForModal = ref([]);
    const expiredDocumentsForModal = ref([]);

    // Categories state
    const loadingCategories = ref(false);
    const categories = ref([]);
    const categoryError = ref(null);
    const organizationType = ref(ORGANIZATION_TYPES.TYPE);

    // Groups state
    const groups = ref([]);
    const types = ref([]);
    const companies = ref([]);

    // Computed para as actions do select
    
    const categoryActions = computed(() => [
    	{
    		key: 'organization',
    		type: ACTION_TYPES.SELECT,
    		selectedValue: organizationType.value,
    		selectedLabel: organizationType.value === ORGANIZATION_TYPES.CATEGORY
    			? 'Por Categoria'
    			: organizationType.value === ORGANIZATION_TYPES.COMPANY
    				? 'Por Empresa'
    				: 'Por Tipo',
    		selectedIcon: organizationType.value === ORGANIZATION_TYPES.CATEGORY
    			? 'folder-open'
    			: organizationType.value === ORGANIZATION_TYPES.COMPANY
    				? 'office'
    				: 'list',
    		options: ORGANIZATION_OPTIONS,
    		placeholder: 'Organizar por'
    	}
    ]);

    // Computed para mostrar os dados corretos baseado no tipo de organização
    const currentData = computed(() => {
    	if (organizationType.value === ORGANIZATION_TYPES.CATEGORY) return categories.value;
    	if (organizationType.value === ORGANIZATION_TYPES.COMPANY) return companies.value;
    	return types.value;
    });

    const currentDataTitle = computed(() => {
    	if (organizationType.value === ORGANIZATION_TYPES.CATEGORY) return 'Arquivos por Categoria';
    	if (organizationType.value === ORGANIZATION_TYPES.COMPANY) return 'Arquivos por Empresa';
    	return 'Arquivos por Tipo';
    });

    const currentDataSubtitle = computed(() => {
    	if (organizationType.value === ORGANIZATION_TYPES.CATEGORY) return 'Organização de arquivos para melhor controle';
    	if (organizationType.value === ORGANIZATION_TYPES.COMPANY) return 'Documentos organizados por empresa';
    	return 'Documentos organizados por tipo';
    });

    const currentDataIcon = computed(() => {
    	if (organizationType.value === ORGANIZATION_TYPES.CATEGORY) return 'folder-open';
    	if (organizationType.value === ORGANIZATION_TYPES.COMPANY) return 'office';
    	return 'list';
    });

    // Recursos do plano do usuário
    const planResources = computed(() => {
    	if (!currentUser.value?.plan) return mockPlanResources.free;
    	return mockPlanResources[currentUser.value.plan] || mockPlanResources.free;
    });

    const loadDocuments = async () => {
    	try {
    		loadingDocuments.value = true;
    		error.value = null;
    		
    		const response = await fetchRecentDocuments(12);
    		
    		if (response.status === API_STATUS.SUCCESS) {
    			documents.value = response.data;
    		} else {
    			error.value = response.message;
    			console.error('Erro ao carregar arquivos:', response.message);
    		}
    	} catch (err) {
    		error.value = 'Erro de conexão. Tente novamente.';
    		console.error('Erro na requisição:', err);
    	} finally {
    		loadingDocuments.value = false;
    	}
    };

    const loadStats = async () => {
    	try {
    		loadingStats.value = true;
    		
    		const response = await fetchDashboardStats();
    		
    		if (response.status === API_STATUS.SUCCESS) {
    			dashboardStats.value = response.data;
    		} else {
    			console.error('Erro ao carregar estatísticas:', response.error);
    		}
    	} catch (err) {
    		console.error('Erro na requisição de estatísticas:', err);
    	} finally {
    		loadingStats.value = false;
    	}
    };

    const loadExpiringDocuments = async () => {
    	try {
    		loadingExpiring.value = true;
    		
    		const response = await fetchExpiringDocuments(30);
    		
    		if (response.status === API_STATUS.SUCCESS) {
    			expiringDocuments.value = response.data;
    		} else {
    			console.error('Erro ao carregar arquivos vencendo:', response.error);
    		}
    	} catch (err) {
    		console.error('Erro na requisição de arquivos vencendo:', err);
    	} finally {
    		loadingExpiring.value = false;
    	}
    };

    const loadCategories = async () => {
    	try {
    		loadingCategories.value = true;
    		categoryError.value = null;
    		
    		const response = await fetchDocumentsByCategory({ limit: 8 });
    		
    		if (response.status === API_STATUS.SUCCESS) {
    			categories.value = response.data;
    		} else {
    			categoryError.value = response.message;
    			console.error('Erro ao carregar categorias:', response.message);
    		}
    	} catch (err) {
    		categoryError.value = 'Erro de conexão. Tente novamente.';
    		console.error('Erro na requisição de categorias:', err);
    	} finally {
    		loadingCategories.value = false;
    	}
    };

    const loadTypes = async () => {
    	try {
    		loadingCategories.value = true;
    		categoryError.value = null;

    		// Simular delay de API
    		await new Promise(resolve => setTimeout(resolve, 800));

    		// Usar mock data de tipos de documento com limit de 8
    		types.value = mockDocumentTypes.slice(0, 8);
    		console.log('Tipos carregados via mock (limit 8):', types.value);

    	} catch (err) {
    		categoryError.value = 'Erro de conexão. Tente novamente.';
    		console.error('Erro na requisição de tipos:', err);
    	} finally {
    		loadingCategories.value = false;
    	}
    };

    const loadCompanies = async () => {
    	try {
    		loadingCategories.value = true;
    		categoryError.value = null;

    		// Simular delay de API
    		await new Promise(resolve => setTimeout(resolve, 800));

    		// Usar mock data de empresas com limit de 8
    		companies.value = mockCompanies.slice(0, 8);
    		console.log('Empresas carregadas via mock (limit 8):', companies.value);

    	} catch (err) {
    		categoryError.value = 'Erro de conexão. Tente novamente.';
    		console.error('Erro na requisição de empresas:', err);
    	} finally {
    		loadingCategories.value = false;
    	}
    };

    // Função para retornar ícone baseado no item (categoria ou tipo)
    const getItemIcon = (item) => {
    	if (organizationType.value === ORGANIZATION_TYPES.CATEGORY) {
    		// Para categorias, usar ícone padrão
    		return 'folder-open';
    	} else if (organizationType.value === ORGANIZATION_TYPES.COMPANY) {
    		// Para empresas, usar ícone padrão office
    		return 'office';
    	} else {
    		// Para tipos de documento, usar ícone padrão list
    		return 'list';
    	}
    };

    onMounted(() => {
    	loadDocuments();
    	loadStats();
    	loadExpiringDocuments();
    	loadTypes();
    	loadRecentActivities();
    	loadCurrentUser();
    });


    const handleAction = (actionName) => {
    	if (actionName === 'addNewDocument') {
    		addNewDocument();
    	} else if (actionName === 'viewAllDocuments') {
    		viewAllDocuments();
    	}
    };

    const viewDocument = async (documentId) => {
    	console.log('Abrindo modal para arquivo:', documentId);
    	selectedDocumentId.value = documentId;
    	showModal.value = true;
    	
    	// Carrega os dados do arquivo
    	await loadSelectedDocument(documentId);
    };

    const loadSelectedDocument = async (documentId) => {
    	try {
    		loadingDocument.value = true;
    		documentError.value = null;
    		selectedDocument.value = null;
    		
    		const response = await fetchDocumentById(documentId);
    		
    		if (response.status === API_STATUS.SUCCESS) {
    			selectedDocument.value = response.data;
    		} else {
    			documentError.value = response.error.message;
    		}
    	} catch (err) {
    		documentError.value = 'Erro de conexão. Tente novamente.';
    		console.error('Erro ao carregar arquivo:', err);
    	} finally {
    		loadingDocument.value = false;
    	}
    };

    const downloadDocument = async (documentId) => {
    	try {
    		console.log('Iniciando download do arquivo:', documentId);
    		
    		const response = await apiDownloadDocument(documentId);
    		
    		if (response.status === API_STATUS.SUCCESS) {
    			// Simula download (em produção, seria um link real)
    			const { downloadUrl, fileName } = response.data;
    			console.log('Download URL gerado:', downloadUrl);
    			console.log('Nome do arquivo:', fileName);
    			
    			// TODO: Implementar download real ou abrir nova aba
    			alert(`Download iniciado: ${fileName}`);
    		} else {
    			console.error('Erro no download:', response.error);
    			alert('Erro ao baixar arquivo. Tente novamente.');
    		}
    	} catch (error) {
    		console.error('Erro na requisição de download:', error);
    		alert('Erro de conexão. Tente novamente.');
    	}
    };

    const addNewDocument = () => {
    	console.log('Adicionar novo arquivo');
    	// TODO: Implementar modal de upload ou navegação para página de upload
    };

    const viewAllDocuments = () => {
    	console.log('Visualizar todos os arquivos');
    	// TODO: Navegação para página de listagem completa
    };

    const closeModal = () => {
    	showModal.value = false;
    	selectedDocumentId.value = null;
    	selectedDocument.value = null;
    	documentError.value = null;
    	loadingDocument.value = false;
    	downloadingDocument.value = false;
    };

    const handleModalDownload = async () => {
    	if (!selectedDocument.value?.id) return;
    	
    	try {
    		downloadingDocument.value = true;
    		
    		const response = await apiDownloadDocument(selectedDocument.value.id);
    		
    		if (response.status === API_STATUS.SUCCESS) {
    			const { downloadUrl, fileName } = response.data;
    			
    			// TODO: Implementar download real
    			console.log('Download URL:', downloadUrl);
    			alert(`Download iniciado: ${fileName}`);
    		} else {
    			alert('Erro ao baixar arquivo. Tente novamente.');
    		}
    	} catch (error) {
    		console.error('Erro no download:', error);
    		alert('Erro de conexão. Tente novamente.');
    	} finally {
    		downloadingDocument.value = false;
    	}
    };

    const retryLoadDocument = () => {
    	if (selectedDocumentId.value) {
    		loadSelectedDocument(selectedDocumentId.value);
    	}
    };

    // Funções auxiliares do modal
    const getDocumentIcon = (type) => {
    	return FILE_ICONS[type] || 'file-empty';
    };


    const getStatusText = (status) => {
    	return FILE_STATUS_LABELS[status] || 'Desconhecido';
    };

    const formatDate = (dateString) => {
    	return moment(dateString).format('DD/MM/YYYY HH:mm');
    };

    const getExpiryClass = (expiryDate) => {
    	if (!expiryDate) return '';

    	const today = moment();
    	const expiry = moment(expiryDate);
    	const diffDays = expiry.diff(today, 'days');
    	
    	if (diffDays <= 0) return 'modalContent_expiryDate--expired';
    	if (diffDays <= 30) return 'modalContent_expiryDate--expiring';
    	return 'modalContent_expiryDate--valid';
    };

    const getExpiryIcon = (expiryDate) => {
    	if (!expiryDate) return 'checkmark';

    	const today = moment();
    	const expiry = moment(expiryDate);
    	const diffDays = expiry.diff(today, 'days');
    	
    	if (diffDays <= 0) return 'times';
    	if (diffDays <= 30) return 'bell';
    	return 'checkmark';
    };

    const getExpiryMessage = (expiryDate) => {
    	if (!expiryDate) return '';

    	const today = moment();
    	const expiry = moment(expiryDate);
    	const diffDays = expiry.diff(today, 'days');
    	
    	if (diffDays <= 0) return 'Arquivo vencido';
    	if (diffDays <= 7) return `Vence em ${diffDays} dia(s)`;
    	if (diffDays <= 30) return `Vence em ${diffDays} dias`;
    	return `Válido por mais ${diffDays} dias`;
    };

    const getDaysUntilExpiry = (expiryDate) => {
    	if (!expiryDate) return 0;

    	const today = moment();
    	const expiry = moment(expiryDate);
    	const diffDays = expiry.diff(today, 'days');
    	
    	return Math.max(0, diffDays);
    };

    const viewAllExpiring = () => {
    	console.log('Visualizar todos os arquivos vencendo');
    	// TODO: Implementar navegação para página de arquivos vencendo
    };

    const openExpiringModal = async () => {
    	try {
    		// Buscar todos os documentos vencendo (não limitado)
    		const response = await fetchExpiringDocuments();

    		if (response.status === API_STATUS.SUCCESS) {
    			expiringDocumentsForModal.value = response.data;
    			showExpiringModal.value = true;
    		} else {
    			console.error('Erro ao buscar documentos vencendo:', response.message);
    		}
    	} catch (error) {
    		console.error('Erro ao abrir modal de documentos vencendo:', error);
    	}
    };

    const closeExpiringModal = () => {
    	showExpiringModal.value = false;
    };

    const openExpiredModal = async () => {
    	try {
    		// Buscar documentos vencidos
    		const response = await fetchExpiredDocuments();

    		if (response.status === API_STATUS.SUCCESS) {
    			expiredDocumentsForModal.value = response.data;
    			showExpiredModal.value = true;
    		} else {
    			console.error('Erro ao buscar documentos vencidos:', response.message);
    		}
    	} catch (error) {
    		console.error('Erro ao abrir modal de documentos vencidos:', error);
    	}
    };

    const closeExpiredModal = () => {
    	showExpiredModal.value = false;
    };

    const viewCategory = (category) => {
    	selectedCategory.value = category;
    	showCategoryModal.value = true;
    };

    const closeCategoryModal = () => {
    	showCategoryModal.value = false;
    	selectedCategory.value = null;
    };

    const handleOrganizationChange = (eventData) => {
    	console.log('Organizando arquivos por:', eventData.value);
    	organizationType.value = eventData.value;

    	// Carregar dados diferentes baseado no tipo de organização selecionado
    	if (eventData.value === 'categoria') {
    		loadCategories();
    	} else if (eventData.value === 'tipo') {
    		loadTypes();
    	} else if (eventData.value === 'empresa') {
    		loadCompanies();
    	}
    };

    // Funções para atividades recentes
    const loadRecentActivities = async () => {
    	try {
    		loadingActivities.value = true;

    		// Simula delay de rede
    		await new Promise(resolve => setTimeout(resolve, 500));

    		recentActivities.value = recentActivitiesData;
    	} catch (err) {
    		console.error('Erro ao carregar atividades recentes:', err);
    	} finally {
    		loadingActivities.value = false;
    	}
    };

    const loadCurrentUser = async () => {
    	try {
    		const response = await fetchCurrentUser();
    		if (response.status === 'success') {
    			currentUser.value = response.data;
    		}
    	} catch (error) {
    		console.error('Erro ao carregar dados do usuário:', error);
    	}
    };

    const getActivityIcon = (type) => {
    	return ACTIVITY_ICONS[type] || 'activity';
    };

    const formatRelativeTime = (timestamp) => {
    	const now = moment();
    	const then = moment(timestamp);
    	const diffMinutes = now.diff(then, 'minutes');
    	const diffHours = now.diff(then, 'hours');
    	const diffDays = now.diff(then, 'days');

    	if (diffMinutes < 1) return 'Agora';
    	if (diffMinutes < 60) return `${diffMinutes}min atrás`;
    	if (diffHours < 24) return `${diffHours}h atrás`;
    	return `${diffDays} dia(s) atrás`;
    };


    const viewAllActivities = () => {
    	console.log('Visualizar todas as atividades');
    	// TODO: Implementar navegação para página de atividades
    };
</script>

<style lang="scss">
    @import '@/assets/css/mediaScreen.scss';
    #modal_viewCategoryModal{
        .sw_modal_container{
            max-width: 1000px !important;
        }
    }
    /* =======================
       STATISTICS BOX
       ======================= */
    .home_stats {
        margin-bottom: 1.5em;
        padding: 1.5em;
        background: rgba(255, 255, 255, 0.6);
        border: 1px solid rgba(229, 231, 235, 0.6);
        border-radius: 1em;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, var(--colorBlue), var(--colorGreen), var(--colorOrange));
            border-radius: 1em 1em 0 0;
        }

        &--loading {
            opacity: 0.7;
            pointer-events: none;
        }
    }

    .home_stats_card {
        display: flex;
        flex-direction: column;
        padding: 1.25em;
        background: var(--backgroundCard);
        border: 1px solid var(--dashboardBorderColor);
        border-radius: 0.75em;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;
        min-height: 90px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
            border-color: rgba(59, 130, 246, 0.2);
        }

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            border-radius: 0.75em 0.75em 0 0;
        }

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            background: rgba(255, 255, 255, 0.9);
        }

        &--wide {
            grid-column: span 2;
            min-height: 90px;
        }

        &--primary::before {
            background: linear-gradient(90deg, #3b82f6, #1d4ed8);
        }

        &--success::before {
            background: linear-gradient(90deg, #10b981, #059669);
        }

        &--secondary::before {
            background: linear-gradient(90deg, #6366f1, #4f46e5);
        }

        &--warning::before {
            background: linear-gradient(90deg, #f59e0b, #d97706);
        }

        &--danger::before {
            background: linear-gradient(90deg, #ef4444, #dc2626);
        }

        &--storage::before {
            background: linear-gradient(90deg, #8b5cf6, #7c3aed);
        }

        &--activity::before {
            background: linear-gradient(90deg, #06b6d4, #0891b2);
        }
    }



    .home_stats_card_storageBar {
        width: 100%;
        height: 4px;
        background: rgba(229, 231, 235, 0.6);
        border-radius: 2px;
        overflow: hidden;
        position: relative;
        margin-top: 1em;
    }

    .home_stats_card_header {
        display: flex;
        align-items: center;
        gap: 1em;
        padding: 0;
        position: relative;
        margin-bottom: 0.75em;

        .home_stats_card_number {
            font-size: 1.5em;
            font-weight: 800;
            color: var(--textPrimary);
            line-height: 1;
            margin: 0;
            letter-spacing: -0.025em;
        }
    }

    .home_stats_card_icon {
        width: 36px;
        height: 36px;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1em;
        color: white;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);

        .sw-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
        }

        .home_stats_card--primary & {
            background: linear-gradient(135deg, var(--colorBlue), #2563eb);
        }

        .home_stats_card--success & {
            background: linear-gradient(135deg, var(--colorGreen), #059669);
        }

        .home_stats_card--secondary & {
            background: linear-gradient(135deg, var(--colorPurple), #7c3aed);
        }

        .home_stats_card--warning & {
            background: linear-gradient(135deg, var(--colorOrange), #d97706);
        }

        .home_stats_card--danger & {
            background: linear-gradient(135deg, var(--colorRed), #dc2626);
        }

        .home_stats_card--storage & {
            background: linear-gradient(135deg, var(--colorPurple), #7c3aed);
        }

        .home_stats_card--activity & {
            background: linear-gradient(135deg, #06b6d4, #0891b2);
        }
    }






    .home_stats_card_body {
        flex: 1;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 0.125em;
    }


    .home_stats_card_title {
        font-size: 0.875em;
        font-weight: 600;
        color: var(--textSecondary);
        margin-bottom: 0.375em;
        line-height: 1.3;
    }

    .home_stats_card_subtitle {
        font-size: 0.75em;
        color: var(--textMuted);
        line-height: 1.4;
        display: flex;
        align-items: center;
        gap: 0.375em;
    }

    .home_stats_card_badge {
        font-size: 0.75em;
        font-weight: 600;
        padding: 0.25em 0.5em;
        border-radius: 0.5em;
        display: inline-block;

        &--success {
            background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.05));
            color: var(--colorGreen);
            border: 1px solid rgba(16, 185, 129, 0.2);
            box-shadow: 0 1px 3px rgba(16, 185, 129, 0.1);
        }
    }

    .home_stats_card_highlight {
        font-weight: 600;
        color: var(--textPrimary);
    }

    .home_stats_card--clickable {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        border-radius: 0.375em;
        padding: 0.25em 0.5em;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: rgba(59, 130, 246, 0.1);
        }
    }

    .home_stats_card_action {
        margin-left: 0.5em;
        color: var(--textSecondary);
        font-size: 0.75em;
        vertical-align: middle;
    }

    .home_stats_card_storage {
        margin-top: 0.5em;
    }


    .home_stats_card_storageProgress {
        height: 100%;
        background: linear-gradient(90deg, var(--colorPurple, #8b5cf6), var(--colorPurpleDark, #7c3aed));
        border-radius: 2px;
        transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;

        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
            animation: storageShimmer 2s infinite;
        }
    }

    @keyframes storageShimmer {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
    }

    /* =======================
       ACTIVITY CARD STYLES - DESIGN APRIMORADO
       ======================= */
    .home_stats_card--activity {
        grid-column: 1 / -1 !important;
        width: 100% !important;
        min-height: 120px;
        background: linear-gradient(135deg, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(248, 250, 252, 0.8) 100%);
        border: 1px solid rgba(6, 182, 212, 0.15);
        position: relative;
        overflow: hidden;

        &::before {
            background: linear-gradient(90deg, #06b6d4, #0891b2);
            height: 3px;
        }
    }

    .home_stats_card_activityHeader {
        display: flex;
        align-items: center;
        gap: 1em;
        margin-bottom: 1.25em;
        padding-bottom: 0.75em;
        border-bottom: 1px solid rgba(6, 182, 212, 0.1);
        
        .home_stats_card_icon {
            width: 2.5em;
            height: 2.5em;
            background: linear-gradient(135deg, #06b6d4, #0891b2);
            box-shadow: 0 4px 12px rgba(6, 182, 212, 0.2);
            border-radius: 0.625em;
            
            .sw-icon {
                font-size: 1.125em;
            }
        }
        
        .home_stats_card_title {
            font-size: 1em;
            font-weight: 700;
            color: var(--textPrimary, #1f2937);
            margin: 0;
        }
        
        .home_stats_card_subtitle {
            font-size: 0.8125em;
            color: var(--textSecondary, #6b7280);
            margin-left: auto;
            font-weight: 500;
        }
    }

    .home_stats_card_activityGrid {
        margin: 0;
    }

    .home_stats_activity_item {
        display: flex;
        align-items: center;
        gap: 0.75em;
        padding: 0.875em;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 0.625em;
        border: 1px solid rgba(6, 182, 212, 0.1);
        transition: all 0.2s ease;
        position: relative;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, #06b6d4, #0891b2);
            border-radius: 0.625em 0.625em 0 0;
            transform: scaleX(0);
            transition: transform 0.2s ease;
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(6, 182, 212, 0.15);
            border-color: rgba(6, 182, 212, 0.2);
            background: rgba(255, 255, 255, 0.8);
            
            &::before {
                transform: scaleX(1);
            }
        }
    }

    .home_stats_activity_icon {
        width: 1.875em;
        height: 1.875em;
        border-radius: 0.5em;
        background: linear-gradient(135deg, #06b6d4, #0891b2);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 0.875em;
        box-shadow: 0 2px 6px rgba(6, 182, 212, 0.25);
        flex-shrink: 0;
        transition: transform 0.2s ease;

        .home_stats_activity_item:hover & {
            transform: scale(1.05);
        }
    }

    .home_stats_activity_data {
        display: flex;
        flex-direction: column;
    }

    .home_stats_activity_usage {
        display: flex;
        align-items: baseline;
        gap: 0.25em;
        line-height: 1;
    }

    .home_stats_activity_used {
        font-size: 1.5em;
        font-weight: 700;
        color: var(--textPrimary, #1f2937);
    }

    .home_stats_activity_separator {
        font-size: 0.875em;
        font-weight: 500;
        color: var(--textSecondary, #6b7280);
        margin: 0 0.125em;
    }

    .home_stats_activity_total {
        font-size: 0.875em;
        font-weight: 500;
        color: var(--textSecondary, #6b7280);
    }

    .home_stats_activity_number {
        font-size: 1.375em;
        font-weight: 700;
        color: var(--textPrimary, #1f2937);
        line-height: 1;
    }

    .home_stats_activity_label {
        font-size: 0.7em;
        font-weight: 500;
        color: var(--textSecondary, #6b7280);
        text-transform: uppercase;
        margin-top: -3px;
    }



    /* =======================
       EXPIRING DOCUMENTS SECTION
       ======================= */
    .home_expiringDocs {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.8));
        border: 1px solid var(--borderColorLight, #e5e7eb);
        border-radius: 1em;
        padding: 1.5em;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        height: fit-content;

        &--loading {
            opacity: 0.7;
        }
    }

    .home_expiringDocs_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1.5em;
        padding-bottom: 1em;
        border-bottom: 1px solid rgba(229, 231, 235, 0.6);
    }

    .home_expiringDocs_title {
        display: flex;
        align-items: center;
        gap: 0.75em;
        
        .sw-icon {
            width: 1.5em;
            height: 1.5em;
            color: var(--colorOrange, #f59e0b);
            font-size: 1.25em;
        }
        
        h3 {
            font-size: 1.125em;
            font-weight: 700;
            color: var(--textPrimary, #1f2937);
            margin: 0;
        }
    }

    .home_expiringDocs_count {
        background: linear-gradient(135deg, var(--colorOrange, #f59e0b), var(--colorOrangeDark, #d97706));
        color: white;
        width: 2em;
        height: 2em;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.875em;
        font-weight: 700;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
    }

    .home_expiringDocs_content {
        min-height: 200px;
        display: flex;
        align-items: start;
        justify-content: center;
    }

    .home_expiringDocs_list {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.75em;

        // Adicionar cursor pointer ao hover nos cards
        :deep(.documentCard) {
            cursor: pointer;
        }
    }

    .home_expiringDocs_item {
        display: flex;
        align-items: center;
        gap: 1em;
        padding: 1em;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(248, 250, 252, 0.6));
        border: 1px solid rgba(229, 231, 235, 0.6);
        border-radius: 0.75em;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            border-color: var(--colorOrange, #f59e0b);
        }
    }

    .home_expiringDocs_itemIcon {
        .sw-icon {
            width: 2.5em;
            height: 2.5em;
            background: linear-gradient(135deg, var(--colorOrange, #f59e0b), var(--colorOrangeDark, #d97706));
            color: white;
            border-radius: 0.5em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.125em;
            flex-shrink: 0;
        }
    }

    .home_expiringDocs_itemContent {
        flex: 1;
        min-width: 0;
    }

    .home_expiringDocs_itemName {
        font-size: 0.875em;
        font-weight: 600;
        color: var(--textPrimary, #1f2937);
        margin-bottom: 0.25em;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .home_expiringDocs_itemExpiry {
        font-size: 0.75em;
        font-weight: 500;
        padding: 0.25em 0.5em;
        border-radius: 0.375em;
        display: inline-block;
        
        &.modalContent_expiryDate--expiring {
            background: rgba(245, 158, 11, 0.15);
            color: var(--colorOrange, #f59e0b);
        }
        
        &.modalContent_expiryDate--expired {
            background: rgba(239, 68, 68, 0.15);
            color: var(--colorRed, #ef4444);
        }
    }

    .home_expiringDocs_itemArrow {
        .sw-icon {
            font-size: 1em;
            color: var(--textSecondary, #6b7280);
            transition: transform 0.2s ease;
        }
        
        .home_expiringDocs_item:hover & .sw-icon {
            transform: translateX(0.25em);
            color: var(--colorOrange, #f59e0b);
        }
    }

    .home_expiringDocs_empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1em;
        padding: 2em;
        text-align: center;
        
        .sw-icon {
            width: 3em;
            height: 3em;
            background: linear-gradient(135deg, var(--colorGreen, #10b981), var(--colorGreenDark, #059669));
            color: white;
            border-radius: 0.75em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5em;
        }
        
        p {
            font-size: 1em;
            font-weight: 600;
            color: var(--textPrimary, #1f2937);
            margin: 0;
        }
        
        span {
            font-size: 0.875em;
            color: var(--textSecondary, #6b7280);
        }
    }

    .home_expiringDocs_loading {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2em;
    }

    .home_expiringDocs_footer {
        margin-top: 1.5em;
        padding-top: 1em;
        border-top: 1px solid rgba(229, 231, 235, 0.6);
        text-align: center;
    }

    /* =======================
       DOCUMENTS SECTION
       ======================= */

    /* =======================
       EMPTY STATE
       ======================= */
    .home_emptyState {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 4em 2em;
        text-align: center;
        gap: 1.5em;
        background: linear-gradient(135deg, rgba(249, 250, 251, 0.8), rgba(243, 244, 246, 0.6));
        border-radius: 1em;
        border: 2px dashed var(--borderColorLight, #d1d5db);
    }

    .home_emptyState_icon {
        width: 5em;
        height: 5em;
        border-radius: 1.25em;
        background: linear-gradient(135deg, var(--colorGray, #6b7280), var(--colorGrayDark, #4b5563));
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.5em;
        box-shadow: 0 8px 20px rgba(107, 114, 128, 0.3);
        opacity: 0.8;
    }

    .home_emptyState_title {
        font-size: 1.25em;
        font-weight: 700;
        color: var(--textPrimary, #1f2937);
        margin: 0;
    }

    .home_emptyState_subtitle {
        font-size: 1em;
        color: var(--textSecondary, #6b7280);
        margin: 0 0 2em 0;
        max-width: 28em;
        line-height: 1.6;
    }

    /* =======================
       RESPONSIVIDADE
       ======================= */
    
    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.4);
        }
        70% {
            box-shadow: 0 0 0 6px rgba(245, 158, 11, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
        }
    }
    
    /* Responsividade da seção de estatísticas */
    @include screen_medias(l, xl) {
    }

    @include screen_medias(m, l) {
        .home_stats {
            padding: 1em;
        }

        .home_stats_card {
            min-height: 80px;
            padding: 0.875em;

            &--wide {
                grid-column: span 2;
                min-height: 75px;
            }
            
            &--activity {
                grid-column: 1 / -1 !important;
                min-height: 90px;
                
                .home_stats_card_activityHeader {
                    margin-bottom: 1em;
                    padding-bottom: 0.625em;
                    
                    .home_stats_card_icon {
                        width: 2.25em;
                        height: 2.25em;
                        
                        .sw-icon {
                            font-size: 1em;
                        }
                    }
                    
                    .home_stats_card_title {
                        font-size: 0.9375em;
                    }
                    
                    .home_stats_card_subtitle {
                        font-size: 0.75em;
                    }
                }
                
                
                .home_stats_activity_item {
                    padding: 0.75em;
                    gap: 0.625em;
                }
                
                .home_stats_activity_icon {
                    width: 2em;
                    height: 2em;
                    font-size: 0.9375em;
                }

                .home_stats_activity_used {
                    font-size: 1.375em;
                }

                .home_stats_activity_number {
                    font-size: 1.25em;
                }

                .home_stats_activity_label {
                    font-size: 0.6875em;
                }
            }
        }
        
        .home_stats_card_icon {
            width: 36px;
            height: 36px;
            font-size: 1em;
        }
        
        .home_stats_card_number {
            font-size: 1.375em;
        }
    }

    @include screen_medias(s, m) {
        .home_stats {
            padding: 1em;
        }
        
        .home_stats_card {
            min-height: 90px;
            padding: 0.875em;
            
            &--wide {
                grid-column: span 1;
                min-height: 80px;
            }
            
            &--activity {
                grid-column: 1 / -1 !important;
                min-height: 140px;
                
                .home_stats_card_activityHeader {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 0.75em;
                    margin-bottom: 1em;
                    
                    .home_stats_card_icon {
                        width: 2.25em;
                        height: 2.25em;
                        
                        .sw-icon {
                            font-size: 1em;
                        }
                    }
                    
                    .home_stats_card_title {
                        font-size: 0.9375em;
                    }
                    
                    .home_stats_card_subtitle {
                        font-size: 0.75em;
                        margin-left: 0;
                    }
                }
                
                
                .home_stats_activity_item {
                    padding: 0.75em;
                    gap: 0.75em;
                    
                    &:hover {
                        transform: translateY(-2px);
                    }
                }
                
                .home_stats_activity_icon {
                    width: 2em;
                    height: 2em;
                    font-size: 0.9375em;

                    .home_stats_activity_item:hover & {
                        transform: scale(1.05);
                    }
                }

                .home_stats_activity_used {
                    font-size: 1.25em;
                }

                .home_stats_activity_number {
                    font-size: 1.25em;
                }

                .home_stats_activity_label {
                    font-size: 0.6875em;
                }
            }
        }
        
        .home_stats_card_icon {
            width: 32px;
            height: 32px;
            font-size: 0.9375em;
        }
        
        .home_stats_card_number {
            font-size: 1.5em;
        }
        
        .home_stats_card_title {
            font-size: 0.8125em;
        }
        
        .home_stats_card_subtitle {
            font-size: 0.6875em;
        }
        
        /* Responsividade para arquivos vencendo */
        .home_expiringDocs {
            padding: 1.25em;
        }
        
        .home_expiringDocs_header {
            margin-bottom: 1.25em;
        }
        
        .home_expiringDocs_title h3 {
            font-size: 1em;
        }
        
        .home_expiringDocs_count {
            width: 1.75em;
            height: 1.75em;
            font-size: 0.8125em;
        }
        
        .home_expiringDocs_content {
            min-height: 180px;
        }
        
        .home_expiringDocs_item {
            padding: 0.875em;
        }
        
        .home_expiringDocs_itemIcon .sw-icon {
            width: 2.25em;
            height: 2.25em;
            font-size: 1em;
        }
        
        .home_expiringDocs_itemName {
            font-size: 0.8125em;
        }
        
        .home_expiringDocs_itemExpiry {
            font-size: 0.6875em;
        }
    }

    @include screen_s {
        .home_stats {
            margin-bottom: 1.5em;
        }
        
        .home_stats_card {
            min-height: 80px;
            padding: 0.75em;
            
            &--wide {
                min-height: 70px;
            }
        }
        
        .home_stats_card_header {
            flex-direction: row;
            justify-content: space-between;
            gap: 0.5em;
        }
        
        .home_stats_card_body {
            text-align: left;
        }
        
        .home_stats_card_icon {
            width: 28px;
            height: 28px;
            font-size: 0.8125em;
        }
        
        .home_stats_card_number {
            font-size: 1.375em;
        }
        
        .home_stats_card_title {
            font-size: 0.75em;
        }
        
        .home_stats_card_subtitle {
            font-size: 0.625em;
            justify-content: flex-start;
        }
        
        .home_stats_card_storage {
            width: 100%;
        }
        
        .home_stats_card_storageText {
            justify-content: flex-start;
            font-size: 0.625em;
        }
        
        /* Mobile para seção de arquivos vencendo */
        .home_expiringDocs {
            margin-top: 1.5em;
            padding: 1em;
        }
        
        .home_expiringDocs_header {
            flex-direction: column;
            align-items: flex-start;
            gap: 1em;
            margin-bottom: 1em;
        }
        
        .home_expiringDocs_title {
            width: 100%;
        }
        
        .home_expiringDocs_title h3 {
            font-size: 0.9375em;
        }
        
        .home_expiringDocs_count {
            align-self: flex-end;
        }
        
        .home_expiringDocs_content {
            min-height: 160px;
        }
        
        .home_expiringDocs_item {
            padding: 0.75em;
            gap: 0.75em;
        }
        
        .home_expiringDocs_itemIcon .sw-icon {
            width: 2em;
            height: 2em;
            font-size: 0.9375em;
        }
        
        .home_expiringDocs_itemName {
            font-size: 0.75em;
        }
        
        .home_expiringDocs_itemExpiry {
            font-size: 0.625em;
            padding: 0.1875em 0.375em;
        }
        
        .home_expiringDocs_empty {
            padding: 1.5em;
            
            .sw-icon {
                width: 2.5em;
                height: 2.5em;
                font-size: 1.25em;
            }
            
            p {
                font-size: 0.9375em;
            }
            
            span {
                font-size: 0.8125em;
            }
        }
    }
    
    /* Responsividade da seção empty state */
    @include screen_medias(s, m) {
        .home_emptyState {
            padding: 3em 1.5em;
        }

        .home_emptyState_icon {
            width: 4em;
            height: 4em;
            font-size: 2em;
        }
    }

    @include screen_s {
        .home_emptyState {
            padding: 2em 1em;
        }

        .home_emptyState_icon {
            width: 3.5em;
            height: 3.5em;
            font-size: 1.75em;
        }

        .home_emptyState_title {
            font-size: 1.125em;
        }

        .home_emptyState_subtitle {
            font-size: 0.875em;
        }
    }

    /* =======================
       MODAL STYLES
       ======================= */
    .modalHeader {
        display: flex;
        align-items: center;
        gap: 1em;
        padding: 0.5em 0;
    }

    .modalHeader_icon {
        .sw-icon {
            width: 2.5em;
            height: 2.5em;
            background: linear-gradient(135deg, var(--colorBlue, #3b82f6), var(--colorBlueDark, #1d4ed8));
            color: white;
            border-radius: 0.5em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25em;
        }
    }

    .modalHeader_title {
        /* Estilos já definidos globalmente em default.scss */
        /* Classes .modal-header-title e .modal-header-subtitle aplicadas */
    }

    .modalContent_loading,
    .modalContent_error {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 3em 2em;
        text-align: center;
        gap: 1em;
        
        p {
            color: var(--textSecondary, #6b7280);
            font-size: 1em;
            margin: 0;
        }
        
        .sw-icon {
            font-size: 3em;
            color: var(--colorRed, #ef4444);
        }
    }

    .modalContent_document {
        display: flex;
        flex-direction: column;
        gap: 2em;
    }

    .modalContent_preview {
        display: flex;
        align-items: center;
        gap: 1.5em;
        padding: 1.5em;
        background: linear-gradient(135deg, rgba(249, 250, 251, 0.8), rgba(243, 244, 246, 0.6));
        border-radius: 0.75em;
        border: 1px solid var(--borderColorLight, #e5e7eb);
    }

    .modalContent_previewIcon {
        .sw-icon {
            width: 4em;
            height: 4em;
            background: linear-gradient(135deg, var(--colorBlue, #3b82f6), var(--colorBlueDark, #1d4ed8));
            color: white;
            border-radius: 0.75em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 2em;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
        }
    }

    .modalContent_previewText {
        p {
            font-size: 1.125em;
            font-weight: 600;
            color: var(--textPrimary, #1f2937);
            margin: 0 0 0.5em 0;
        }
        
        span {
            font-size: 0.875em;
            color: var(--textSecondary, #6b7280);
        }
    }

    .modalContent_sections {
        display: flex;
        flex-direction: column;
        gap: 2em;
    }

    .modalContent_section {
        h4 {
            font-size: 1em;
            font-weight: 700;
            color: var(--textPrimary, #1f2937);
            margin: 0 0 1em 0;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }
    }

    .modalContent_grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(15em, 1fr));
        gap: 1.5em;
    }

    .modalContent_field {
        label {
            display: block;
            font-size: 0.8125em;
            font-weight: 600;
            color: var(--textSecondary, #6b7280);
            text-transform: uppercase;
            letter-spacing: 0.025em;
            margin-bottom: 0.5em;
        }
        
        span {
            font-size: 0.9375em;
            color: var(--textPrimary, #1f2937);
            font-weight: 500;
        }
    }

    .modalContent_badge {
        background: rgba(59, 130, 246, 0.1);
        color: var(--colorBlue, #3b82f6);
        padding: 0.25em 0.75em;
        border-radius: 0.375em;
        font-weight: 600;
        font-size: 0.8125em !important;
        text-transform: uppercase;
        letter-spacing: 0.025em;
    }

    .modalContent_status {
        padding: 0.25em 0.75em;
        border-radius: 0.5em;
        font-weight: 600;
        font-size: 0.8125em !important;
        text-transform: uppercase;
        letter-spacing: 0.025em;
        
        &--active {
            background: rgba(16, 185, 129, 0.1);
            color: var(--colorGreen, #10b981);
        }
        
        &--expiring {
            background: rgba(245, 158, 11, 0.1);
            color: var(--colorOrange, #f59e0b);
        }
        
        &--expired {
            background: rgba(239, 68, 68, 0.1);
            color: var(--colorRed, #ef4444);
        }
    }

    .modalContent_expiry {
        display: flex;
        gap: 1em;
    }

    .modalContent_expiryDate {
        display: flex;
        align-items: center;
        gap: 1em;
        padding: 1em;
        border-radius: 0.75em;
        border: 1px solid;
        
        .sw-icon {
            font-size: 1.5em;
        }
        
        strong {
            display: block;
            font-size: 1em;
            margin-bottom: 0.25em;
        }
        
        span {
            font-size: 0.875em;
            opacity: 0.8;
        }
        
        &--valid {
            background: rgba(16, 185, 129, 0.1);
            border-color: rgba(16, 185, 129, 0.3);
            color: var(--colorGreen, #10b981);
        }
        
        &--expiring {
            background: rgba(245, 158, 11, 0.1);
            border-color: rgba(245, 158, 11, 0.3);
            color: var(--colorOrange, #f59e0b);
        }
        
        &--expired {
            background: rgba(239, 68, 68, 0.1);
            border-color: rgba(239, 68, 68, 0.3);
            color: var(--colorRed, #ef4444);
        }
    }

    .modalContent_tags {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5em;
    }

    .modalContent_tag {
        padding: 0.5em 1em;
        background: var(--backgroundInsideBox, #f8fafc);
        color: var(--textPrimary, #1f2937);
        border-radius: 2em;
        font-size: 0.8125em;
        font-weight: 500;
        border: 1px solid var(--borderColorLight, #e5e7eb);
    }

    .modalActions {
        display: flex;
        gap: 1em;
        justify-content: flex-end;
        padding-top: 1.5em;
        border-top: 1px solid var(--borderColorLight, #e5e7eb);
        margin-top: 1.5em;
    }

    .categoryCard {
        background: linear-gradient(135deg, var(--backgroundCard), #ffffff);
        border-radius: 0.875em;
        padding: 1.25em;
        display: flex;
        flex-direction: column;
        height: 100%;
        border: 1px solid var(--borderColorLight, #e5e7eb);
        transition: all 0.3s ease;
        box-shadow: var(--boxShadowSm);
        min-height: 200px;

        &:hover {
            transform: translateY(-5px);
            box-shadow: var(--boxShadowLg);
            border-color: var(--linkColor);
        }
    }

    .categoryCard_header {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 0.75em;
        margin-bottom: 1.25em;
    }

    .categoryCard_icon {
        .sw-icon {
            width: 2.5em;
            height: 2.5em;
            background: linear-gradient(135deg, var(--colorBlue), var(--colorBlueDark));
            color: white;
            border-radius: 0.625em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25em;
            box-shadow: 0 3px 10px rgba(59, 130, 246, 0.3);
        }
    }

    .categoryCard_image {
        width: 2.5em;
        height: 2.5em;
        border-radius: 0.625em;
        overflow: hidden;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
        border: 2px solid white;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .categoryCard_info {
        text-align: center;
        width: 100%;

        &--noIcon {
            margin-top: 0;
        }
    }

    .categoryCard_title {
        font-size: 1em;
        font-weight: 700;
        color: var(--textPrimary);
        line-height: 1.2;
        margin-bottom: 0.25em;
    }

    .categoryCard_count {
        font-size: 0.8125em;
        color: var(--textSecondary);
        font-weight: 500;
    }

    .categoryCard_body {
        margin-top: auto;
        padding-top: 1em;
        border-top: 1px solid var(--borderColorLight);
        display: flex;
        flex-direction: column;
        gap: 1em;
    }

    .categoryCard_stats {
        display: flex;
        justify-content: center;
        gap: 1.25em;
    }

    .categoryCard_stat {
        text-align: center;
    }

    .categoryCard_stat_value {
        font-size: 1.125em;
        font-weight: 700;
        display: block;
        line-height: 1;

        &--expiring {
            color: var(--colorOrange);
        }

        &--expired {
            color: var(--colorRed);
        }
    }

    .categoryCard_stat_label {
        font-size: 0.6875em;
        color: var(--textMuted);
        text-transform: uppercase;
        margin-top: 0.125em;
        font-weight: 500;
    }

    .categoryModalContent {
        padding: 1.5em;
    }

    /* =======================
       RECENT ACTIVITIES SECTION - CLEAN DESIGN
       ======================= */
    .home_recentActivities {
        background: var(--backgroundCard, #ffffff);
        border: 1px solid var(--borderColorLight, #e5e7eb);
        border-radius: 1em;
        padding: 1.5em;
        box-shadow: var(--boxShadowSm);
        height: fit-content;
        margin-bottom: 1.5em;

        &--loading {
            opacity: 0.7;
        }
    }

    .home_recentActivities_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1.5em;
        padding-bottom: 1em;
        border-bottom: 1px solid var(--borderColorLight, #e5e7eb);
    }

    .home_recentActivities_title {
        display: flex;
        align-items: center;
        gap: 0.75em;
        
        .sw-icon {
            width: 1.75em;
            height: 1.75em;
            color: var(--colorBlue, #3b82f6);
            font-size: 1.125em;
        }
        
        h3 {
            font-size: 1.125em;
            font-weight: 700;
            color: var(--textPrimary, #1f2937);
            margin: 0;
        }
    }

    .home_recentActivities_count {
        background: var(--colorBlue, #3b82f6);
        color: white;
        width: 2em;
        height: 2em;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.875em;
        font-weight: 700;
        box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
    }

    .home_recentActivities_content {
        max-height: 450px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .home_recentActivities_list {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.625em;
    }

    .home_recentActivities_item {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;
        padding: 0.875em 1em;
        background: white;
        border: 1px solid var(--borderColorLight, #e5e7eb);
        border-radius: 0.5em;
        transition: all 0.2s ease;

        &:hover {
            background: var(--backgroundLight, #f8fafc);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }
    }

    .home_recentActivities_itemContent {
        flex: 1;
        min-width: 0;
    }

    .home_recentActivities_itemTitle {
        display: flex;
        flex-direction: column;
        gap: 0.375em;
        margin-bottom: 0.375em;
    }

    .home_recentActivities_itemHeader {
        display: flex;
        align-items: center;
        gap: 0.625em;
    }

    .home_recentActivities_itemIcon {
        .sw-icon {
            width: 1.75em;
            height: 1.75em;
            border-radius: 0.375em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.75em;
            flex-shrink: 0;
            color: white;
        }

        &--upload .sw-icon {
            background: linear-gradient(135deg, var(--colorBlue, #3b82f6), var(--colorBlueDark, #2563eb));
        }

        &--alert .sw-icon {
            background: linear-gradient(135deg, var(--colorOrange, #f59e0b), var(--colorOrangeDark, #d97706));
        }

        &--share .sw-icon {
            background: linear-gradient(135deg, var(--colorGreen, #10b981), var(--colorGreenDark, #059669));
        }

        &--download .sw-icon {
            background: linear-gradient(135deg, var(--colorPurple, #8b5cf6), var(--colorPurpleDark, #7c3aed));
        }

        &--access .sw-icon {
            background: linear-gradient(135deg, var(--colorGray, #6b7280), #4b5563);
        }
    }

    .activity-action {
        font-size: 0.8125em;
        font-weight: 600;
        color: var(--textPrimary, #1f2937);
        line-height: 1.3;
    }

    .activity-description {
        font-size: 0.75em;
        color: var(--textSecondary, #6b7280);
        font-weight: 500;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .home_recentActivities_itemTime {
        font-size: 0.6875em;
        color: var(--textMuted, #9ca3af);
        font-weight: 500;
    }

    .home_recentActivities_empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1em;
        padding: 2.5em 2em;
        text-align: center;
        
        .sw-icon {
            width: 3em;
            height: 3em;
            background: var(--colorBlue, #3b82f6);
            color: white;
            border-radius: 0.75em;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5em;
        }
        
        p {
            font-size: 1em;
            font-weight: 600;
            color: var(--textPrimary, #1f2937);
            margin: 0;
        }
        
        span {
            font-size: 0.875em;
            color: var(--textSecondary, #6b7280);
            line-height: 1.4;
        }
    }

    .home_recentActivities_loading {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2.5em;
        min-height: 200px;
    }

    .home_recentActivities_footer {
        margin-top: 1.5em;
        padding-top: 1em;
        border-top: 1px solid var(--borderColorLight, #e5e7eb);
        text-align: center;
    }

    /* Responsividade para atividades recentes */
    @include screen_medias(s, m) {
        .home_recentActivities {
            padding: 1.25em;
            margin-bottom: 1.25em;
        }
        
        .home_recentActivities_header {
            margin-bottom: 1.25em;
        }
        
        .home_recentActivities_title h3 {
            font-size: 1em;
        }
        
        .home_recentActivities_count {
            width: 1.75em;
            height: 1.75em;
            font-size: 0.8125em;
        }
        
        .home_recentActivities_content {
            min-height: 180px;
        }
        
        .home_recentActivities_item {
            padding: 0.875em;
        }
        
        .home_recentActivities_itemIcon .sw-icon {
            width: 2em;
            height: 2em;
            font-size: 0.9375em;
        }
        
        .home_recentActivities_itemTitle {
            font-size: 0.8125em;
        }
        
        .home_recentActivities_itemTime {
            font-size: 0.6875em;
        }
    }

    @include screen_s {
        .home_recentActivities {
            padding: 1em;
            margin-bottom: 1em;
        }
        
        .home_recentActivities_header {
            flex-direction: column;
            align-items: flex-start;
            gap: 1em;
            margin-bottom: 1em;
        }
        
        .home_recentActivities_title {
            width: 100%;
        }
        
        .home_recentActivities_title h3 {
            font-size: 0.9375em;
        }
        
        .home_recentActivities_count {
            align-self: flex-end;
        }
        
        .home_recentActivities_content {
            min-height: 160px;
        }
        
        .home_recentActivities_item {
            padding: 0.75em;
            gap: 0.75em;
        }
        
        .home_recentActivities_itemIcon .sw-icon {
            width: 1.875em;
            height: 1.875em;
            font-size: 0.875em;
        }
        
        .home_recentActivities_itemTitle {
            font-size: 0.75em;
        }
        
        .home_recentActivities_itemTime {
            font-size: 0.625em;
        }
        
        .home_recentActivities_empty {
            padding: 1.5em;
            
            .sw-icon {
                width: 2.5em;
                height: 2.5em;
                font-size: 1.25em;
            }
            
            p {
                font-size: 0.9375em;
            }
            
            span {
                font-size: 0.8125em;
            }
        }
    }

    /* Responsividade para cards de categoria */
    @include screen_medias(l, xl) {
        .categoryCard {
            min-height: 180px;
            padding: 1em;
        }

        .categoryCard_icon .sw-icon {
            width: 2.25em;
            height: 2.25em;
            font-size: 1.125em;
        }

        .categoryCard_image {
            width: 2.25em;
            height: 2.25em;
        }

        .categoryCard_title {
            font-size: 0.9375em;
        }

        .categoryCard_count {
            font-size: 0.75em;
        }
    }

    @include screen_medias(m, l) {
        .categoryCard {
            min-height: 160px;
            padding: 0.875em;
        }

        .categoryCard_header {
            margin-bottom: 1em;
        }

        .categoryCard_icon .sw-icon {
            width: 2em;
            height: 2em;
            font-size: 1em;
        }

        .categoryCard_image {
            width: 2em;
            height: 2em;
        }

        .categoryCard_stats {
            gap: 1em;
        }

        .categoryCard_stat_value {
            font-size: 1em;
        }
    }

    @include screen_medias(s, m) {
        .categoryCard {
            min-height: 150px;
            padding: 0.75em;
        }

        .categoryCard_header {
            gap: 0.625em;
            margin-bottom: 0.875em;
        }

        .categoryCard_body {
            padding-top: 0.875em;
            gap: 0.875em;
        }

        .categoryCard_stats {
            gap: 0.875em;
        }
    }

    @include screen_s {
        .categoryCard {
            min-height: 130px;
            padding: 0.75em;
        }

        .categoryCard_header {
            flex-direction: row;
            text-align: left;
            gap: 0.75em;
        }

        .categoryCard_info {
            text-align: left;
        }

        .categoryCard_icon .sw-icon {
            width: 1.875em;
            height: 1.875em;
            font-size: 0.9375em;
        }

        .categoryCard_image {
            width: 1.875em;
            height: 1.875em;
        }

        .categoryCard_title {
            font-size: 0.875em;
        }

        .categoryCard_count {
            font-size: 0.6875em;
        }
    }
</style>